import Tabs from "src/components/Tabs";
import Layout from "src/router/AuthenticatedRouter/Layout";
import Profile from "./Tabs/Profile";
import Users from "./Tabs/Users";
import { useSearchParams } from "react-router-dom";
import Button from "src/components/Button";
import EditButton from "src/components/EditButton";
import { ReactComponent as Plus } from "src/assets/svg/+3.svg";
import { useEffect, useState } from "react";
import InviteModal from "./Components/InviteModal";
import { ClientInvite } from "src/types/models/ClientInvite";
import { getInvites } from "src/network/client_invite";
import useLoader from "src/hooks/useLoader";
import { useAppDispatch, useAppSelector } from "src/redux/store";
import { unlinkCompanyAts } from "src/network/company_ats";
import ATS from "./Tabs/ATS";
import { setClient } from "src/redux/slices/client";
import Client from "src/types/models/Client";

export type SettingTab = "Profile" | "Users" | "ATS";

export const tabs: SettingTab[] = ["Profile", "Users", "ATS"];

const SettingsPage = () => {
  const dispatch = useAppDispatch();
  const [, setSearchParam] = useSearchParams();
  const client = useAppSelector((r) => r.client.client);
  const ats = client?.Company.Ats;
  const [open, setOpen] = useState(false);
  const [invites, setInvites] = useState<ClientInvite[]>();
  const [params] = useSearchParams();
  const tab = params.get("tab") || tabs[0];
  const fetchInvites = async () => {
    const invites = await getInvites();
    setInvites(invites);
  };
  const { ldng } = useLoader(fetchInvites, { errorMsg: "Error fetching invites" });

  const unlinkATS = async () => {
    if (!client) return;
    await unlinkCompanyAts();
    const _client: Client = { ...client, Company: { ...client.Company, Ats: undefined } };
    dispatch(setClient(_client));
    setSearchParam(`tab=Profile`);
  };
  const { ldng: unlink, loading: unlinking } = useLoader(unlinkATS, {
    successMsg: "ATS Unlinked",
    errorMsg: "Error unlinking ATS"
  });

  useEffect(() => {
    ldng();
  }, []);

  let rightChildren;
  switch (tab) {
    case tabs[0]:
      rightChildren = <EditButton form="client_form" />;
      break;
    case tabs[1]:
      rightChildren = (
        <Button disabled={!invites} onClick={() => setOpen(true)} shapeVariant={2}>
          <Plus className="mr-[10px] h-6 w-6" /> Invite Recruiter
        </Button>
      );

      break;
    case tabs[2]:
      rightChildren = (
        <Button loading={unlinking} variant="white_red" onClick={unlink} shapeVariant={2}>
          Disconnect Now
        </Button>
      );
      break;
    default:
      break;
  }

  const _tabs: SettingTab[] = ats ? tabs : ["Profile", "Users"];

  return (
    <Layout title={`Settings`} className="" rightChildren={rightChildren}>
      <Tabs
        withSearchParam
        tabs={_tabs}
        contents={[
          <Profile />,
          <Users setInvites={setInvites} invites={invites} />,
          <ATS unlink={unlink} unlinking={unlinking} />
        ]}
      />

      {open && <InviteModal setInvites={setInvites} invites={invites || []} onChange={setOpen} />}
    </Layout>
  );
};

export default SettingsPage;
